/* Keep selected departments and offers open during theme-editor changes. */
if (!customElements.get('fa-department-accordion')) {
  customElements.define('fa-department-accordion', class extends HTMLElement {
    connectedCallback() {
      this.onBlockSelect = (event) => {
        const details = event.target.closest('details') || event.target.querySelector('details');
        if (details) details.open = true;
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });
}
